import { useSyncExternalStore } from 'react';

export type ToastTone = 'ok' | 'danger' | 'info';
export type Toast = { id: number; tone: ToastTone; title: string; detail?: string | undefined };

let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function dismissToast(id: number) {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

function push(tone: ToastTone, title: string, detail?: string) {
  // Collapse identical toasts fired in quick succession (e.g. several queries failing at once).
  if (toasts.some((t) => t.title === title && t.tone === tone)) return;
  const id = nextId++;
  toasts = [...toasts.slice(-3), { id, tone, title, detail }];
  emit();
  setTimeout(() => dismissToast(id), tone === 'danger' ? 7000 : 4000);
}

/** Callable outside React (e.g. from the React Query mutation cache). */
export const toast = {
  success: (title: string, detail?: string) => push('ok', title, detail),
  error: (title: string, detail?: string) => push('danger', title, detail),
  info: (title: string, detail?: string) => push('info', title, detail),
};

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => toasts,
    () => toasts,
  );
}
